import * as ambassadorWixAutomationsV2Activation from './automations-v2-activation-activations.http.js';
import * as ambassadorWixAutomationsV2ActivationTypes from './automations-v2-activation-activations.types.js';
import * as ambassadorWixAutomationsV2ActivationUniversalTypes from './automations-v2-activation-activations.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function reportEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsV2ActivationUniversalTypes.ReportEventRequest,
  ambassadorWixAutomationsV2ActivationTypes.ReportEventRequest,
  ambassadorWixAutomationsV2ActivationUniversalTypes.ReportEventResponse,
  ambassadorWixAutomationsV2ActivationTypes.ReportEventResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsV2Activation.reportEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/events/report',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkReportEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsV2ActivationUniversalTypes.BulkReportEventRequest,
  ambassadorWixAutomationsV2ActivationTypes.BulkReportEventRequest,
  ambassadorWixAutomationsV2ActivationUniversalTypes.BulkReportEventResponse,
  ambassadorWixAutomationsV2ActivationTypes.BulkReportEventResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsV2Activation.bulkReportEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/events/bulk-report',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCancelEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsV2ActivationUniversalTypes.BulkCancelEventRequest,
  ambassadorWixAutomationsV2ActivationTypes.BulkCancelEventRequest,
  ambassadorWixAutomationsV2ActivationUniversalTypes.BulkCancelEventResponse,
  ambassadorWixAutomationsV2ActivationTypes.BulkCancelEventResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsV2Activation.bulkCancelEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/events/bulk-cancel',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsV2ActivationUniversalTypes.CancelEventRequest,
  ambassadorWixAutomationsV2ActivationTypes.CancelEventRequest,
  ambassadorWixAutomationsV2ActivationUniversalTypes.CancelEventResponse,
  ambassadorWixAutomationsV2ActivationTypes.CancelEventResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsV2Activation.cancelEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/events/cancel',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function rerunActivation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsV2ActivationUniversalTypes.RerunActivationRequest,
  ambassadorWixAutomationsV2ActivationTypes.RerunActivationRequest,
  ambassadorWixAutomationsV2ActivationUniversalTypes.RerunActivationResponse,
  ambassadorWixAutomationsV2ActivationTypes.RerunActivationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsV2Activation.rerunActivation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/events/rerun-activation',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function reportActionInvocationCompleted(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAutomationsV2ActivationUniversalTypes.ReportActionInvocationCompletedRequest,
  ambassadorWixAutomationsV2ActivationTypes.ReportActionInvocationCompletedRequest,
  ambassadorWixAutomationsV2ActivationUniversalTypes.ReportActionInvocationCompletedResponse,
  ambassadorWixAutomationsV2ActivationTypes.ReportActionInvocationCompletedResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAutomationsV2Activation.reportActionInvocationCompleted(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/report-action-invocation-completed',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Activation as ActivationOriginal,
  Automation as AutomationOriginal,
  AutomationOriginInfoOneOf as AutomationOriginInfoOneOfOriginal,
  AIMetadata as AIMetadataOriginal,
  ActionSettings as ActionSettingsOriginal,
  Domain as DomainOriginal,
  DomainWithLiterals as DomainWithLiteralsOriginal,
  TriggerSettings as TriggerSettingsOriginal,
  Enrichment as EnrichmentOriginal,
  AuditInfo as AuditInfoOriginal,
  AuditInfoIdOneOf as AuditInfoIdOneOfOriginal,
  AutomationConfiguration as AutomationConfigurationOriginal,
  TimeUnit as TimeUnitOriginal,
  TimeUnitWithLiterals as TimeUnitWithLiteralsOriginal,
  Filter as FilterOriginal,
  FutureDateActivationOffset as FutureDateActivationOffsetOriginal,
  RateLimit as RateLimitOriginal,
  FilterValueSelection as FilterValueSelectionOriginal,
  ConditionExpressionGroup as ConditionExpressionGroupOriginal,
  Operator as OperatorOriginal,
  OperatorWithLiterals as OperatorWithLiteralsOriginal,
  ActionCodeSnippet as ActionCodeSnippetOriginal,
  CodeSnippetLanguage as CodeSnippetLanguageOriginal,
  CodeSnippetLanguageWithLiterals as CodeSnippetLanguageWithLiteralsOriginal,
  SplitActionPath as SplitActionPathOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  AppDefinedAction as AppDefinedActionOriginal,
  ConditionAction as ConditionActionOriginal,
  CodeConditionAction as CodeConditionActionOriginal,
  DelayAction as DelayActionOriginal,
  RateLimitAction as RateLimitActionOriginal,
  SetVariablesAction as SetVariablesActionOriginal,
  OutputAction as OutputActionOriginal,
  ActionSplitAction as ActionSplitActionOriginal,
  MergeAction as MergeActionOriginal,
  AutomationConfigurationStatus as AutomationConfigurationStatusOriginal,
  AutomationConfigurationStatusWithLiterals as AutomationConfigurationStatusWithLiteralsOriginal,
  Trigger as TriggerOriginal,
  AutomationConfigurationAction as AutomationConfigurationActionOriginal,
  AutomationConfigurationActionInfoOneOf as AutomationConfigurationActionInfoOneOfOriginal,
  FilterableAppDefinedActions as FilterableAppDefinedActionsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  ApplicationOrigin as ApplicationOriginOriginal,
  PreinstalledOrigin as PreinstalledOriginOriginal,
  AutomationSettings as AutomationSettingsOriginal,
  DraftInfo as DraftInfoOriginal,
  Enrichments as EnrichmentsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  AutoArchivePolicy as AutoArchivePolicyOriginal,
  Notes as NotesOriginal,
  Note as NoteOriginal,
  Position as PositionOriginal,
  Offset as OffsetOriginal,
  Dimensions as DimensionsOriginal,
  ActivationInitiationSourceInfo as ActivationInitiationSourceInfoOriginal,
  ActivationInitiationSourceInfoInitiationSourceInfoOneOf as ActivationInitiationSourceInfoInitiationSourceInfoOneOfOriginal,
  ActivationInitiationSource as ActivationInitiationSourceOriginal,
  ActivationInitiationSourceWithLiterals as ActivationInitiationSourceWithLiteralsOriginal,
  ManualActivationInfo as ManualActivationInfoOriginal,
  RerunActivationInfo as RerunActivationInfoOriginal,
  InitiatorInfo as InitiatorInfoOriginal,
  ActivationStatusChanged as ActivationStatusChangedOriginal,
  ActivationStatusChangedStatusInfoOneOf as ActivationStatusChangedStatusInfoOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  CancellationReason as CancellationReasonOriginal,
  CancellationReasonWithLiterals as CancellationReasonWithLiteralsOriginal,
  Identity as IdentityOriginal,
  ErrorReason as ErrorReasonOriginal,
  ErrorReasonWithLiterals as ErrorReasonWithLiteralsOriginal,
  SkipReason as SkipReasonOriginal,
  SkipReasonWithLiterals as SkipReasonWithLiteralsOriginal,
  ActivationStatusChangedStatus as ActivationStatusChangedStatusOriginal,
  ActivationStatusChangedStatusWithLiterals as ActivationStatusChangedStatusWithLiteralsOriginal,
  Metadata as MetadataOriginal,
  InitiatedStatusInfo as InitiatedStatusInfoOriginal,
  ActivationStatusChangedStartedStatusInfo as ActivationStatusChangedStartedStatusInfoOriginal,
  ScheduledStatusInfo as ScheduledStatusInfoOriginal,
  CancelledStatusInfo as CancelledStatusInfoOriginal,
  ActivationStatusChangedFailedStatusInfo as ActivationStatusChangedFailedStatusInfoOriginal,
  SkippedStatusInfo as SkippedStatusInfoOriginal,
  ScheduleRequest as ScheduleRequestOriginal,
  Schedule as ScheduleOriginal,
  ScheduledAction as ScheduledActionOriginal,
  Delay as DelayOriginal,
  DelayOfOneOf as DelayOfOneOfOriginal,
  SimpleDelay as SimpleDelayOriginal,
  Units as UnitsOriginal,
  UnitsWithLiterals as UnitsWithLiteralsOriginal,
  ScheduleStatus as ScheduleStatusOriginal,
  ScheduleStatusWithLiterals as ScheduleStatusWithLiteralsOriginal,
  TriggerInfo as TriggerInfoOriginal,
  ScheduleResponse as ScheduleResponseOriginal,
  CancelPendingScheduleRequest as CancelPendingScheduleRequestOriginal,
  CancelPendingScheduleRequestByOneOf as CancelPendingScheduleRequestByOneOfOriginal,
  CancelPendingScheduleResponse as CancelPendingScheduleResponseOriginal,
  UpdatePendingSchedulesPayloadRequest as UpdatePendingSchedulesPayloadRequestOriginal,
  UpdatePendingSchedulesPayloadResponse as UpdatePendingSchedulesPayloadResponseOriginal,
  GetScheduleRequest as GetScheduleRequestOriginal,
  GetScheduleResponse as GetScheduleResponseOriginal,
  UpdateScheduleStatusRequest as UpdateScheduleStatusRequestOriginal,
  UpdateScheduleStatusResponse as UpdateScheduleStatusResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  ConsumeReportEventRequest as ConsumeReportEventRequestOriginal,
  EventInfo as EventInfoOriginal,
  Idempotency as IdempotencyOriginal,
  BatchActivationRequest as BatchActivationRequestOriginal,
  ActivationRequest as ActivationRequestOriginal,
  Runtime as RuntimeOriginal,
  Scheduler as SchedulerOriginal,
  AsyncAction as AsyncActionOriginal,
  ActionData as ActionDataOriginal,
  Action as ActionOriginal,
  ActionActionOneOf as ActionActionOneOfOriginal,
  ServiceMapping as ServiceMappingOriginal,
  IfFilter as IfFilterOriginal,
  SwitchFilter as SwitchFilterOriginal,
  Case as CaseOriginal,
  DelayHelper as DelayHelperOriginal,
  RateLimiting as RateLimitingOriginal,
  ConditionFilter as ConditionFilterOriginal,
  BlockType as BlockTypeOriginal,
  BlockTypeWithLiterals as BlockTypeWithLiteralsOriginal,
  ConditionBlock as ConditionBlockOriginal,
  CodeConditionFilter as CodeConditionFilterOriginal,
  CodeSnippet as CodeSnippetOriginal,
  Language as LanguageOriginal,
  LanguageWithLiterals as LanguageWithLiteralsOriginal,
  Output as OutputOriginal,
  SetVariables as SetVariablesOriginal,
  SplitAction as SplitActionOriginal,
  Path as PathOriginal,
  Service as ServiceOriginal,
  SystemHelper as SystemHelperOriginal,
  SystemHelperHelperOneOf as SystemHelperHelperOneOfOriginal,
  SpiAction as SpiActionOriginal,
  ActivationSource as ActivationSourceOriginal,
  ActivationSourceOfOneOf as ActivationSourceOfOneOfOriginal,
  ActionsData as ActionsDataOriginal,
  ScheduleActivationRequested as ScheduleActivationRequestedOriginal,
  ActivationContinuedAfterSchedule as ActivationContinuedAfterScheduleOriginal,
  ReportEventRequest as ReportEventRequestOriginal,
  ReportEventResponse as ReportEventResponseOriginal,
  BulkReportEventRequest as BulkReportEventRequestOriginal,
  BulkReportEventResponse as BulkReportEventResponseOriginal,
  BulkReportEventResult as BulkReportEventResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkCancelEventRequest as BulkCancelEventRequestOriginal,
  BulkCancelEventResponse as BulkCancelEventResponseOriginal,
  BulkCancelEventResult as BulkCancelEventResultOriginal,
  CancelEventRequest as CancelEventRequestOriginal,
  CancelEventResponse as CancelEventResponseOriginal,
  V1RunAutomationRequest as V1RunAutomationRequestOriginal,
  V1RunAutomationRequestIdentifierOneOf as V1RunAutomationRequestIdentifierOneOfOriginal,
  IdentifierType as IdentifierTypeOriginal,
  IdentifierTypeWithLiterals as IdentifierTypeWithLiteralsOriginal,
  PreinstalledIdentifier as PreinstalledIdentifierOriginal,
  AutomationIdentifier as AutomationIdentifierOriginal,
  V1RunAutomationResponse as V1RunAutomationResponseOriginal,
  TestAutomationRequest as TestAutomationRequestOriginal,
  TestAutomationRequestIdentifierOneOf as TestAutomationRequestIdentifierOneOfOriginal,
  TestAutomationResponse as TestAutomationResponseOriginal,
  RerunActivationRequest as RerunActivationRequestOriginal,
  RunOptions as RunOptionsOriginal,
  RerunActivationResponse as RerunActivationResponseOriginal,
  ReportDomainEventRequest as ReportDomainEventRequestOriginal,
  ReportDomainEventResponse as ReportDomainEventResponseOriginal,
  ReportAccountLevelEventRequest as ReportAccountLevelEventRequestOriginal,
  ReportAccountLevelEventResponse as ReportAccountLevelEventResponseOriginal,
  ExecuteFromActionRequest as ExecuteFromActionRequestOriginal,
  ExecuteFromActionResponse as ExecuteFromActionResponseOriginal,
  ActivationScheduleCompleted as ActivationScheduleCompletedOriginal,
  Empty as EmptyOriginal,
  ActionRetryRequest as ActionRetryRequestOriginal,
  ActivationContext as ActivationContextOriginal,
  RuntimeStatus as RuntimeStatusOriginal,
  RuntimeStatusWithLiterals as RuntimeStatusWithLiteralsOriginal,
  ResumeAfterAsyncActionCompleted as ResumeAfterAsyncActionCompletedOriginal,
  ResumeAfterAsyncActionCompletedStatusInfoOneOf as ResumeAfterAsyncActionCompletedStatusInfoOneOfOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  SuccessInfo as SuccessInfoOriginal,
  FailureInfo as FailureInfoOriginal,
  ActivationActionStatusChanged as ActivationActionStatusChangedOriginal,
  ActivationActionStatusChangedInfoOneOf as ActivationActionStatusChangedInfoOneOfOriginal,
  ActivationActionStatusChangedStatusInfoOneOf as ActivationActionStatusChangedStatusInfoOneOfOriginal,
  RetryInfo as RetryInfoOriginal,
  StartedStatusInfoAppDefinedActionInfo as StartedStatusInfoAppDefinedActionInfoOriginal,
  StartedStatusInfoDelayActionInfo as StartedStatusInfoDelayActionInfoOriginal,
  InvokedAsyncStatusInfoAppDefinedActionInfo as InvokedAsyncStatusInfoAppDefinedActionInfoOriginal,
  ExpressionEvaluationResult as ExpressionEvaluationResultOriginal,
  EndedStatusInfoAppDefinedActionInfo as EndedStatusInfoAppDefinedActionInfoOriginal,
  ConditionActionInfo as ConditionActionInfoOriginal,
  CodeConditionActionInfo as CodeConditionActionInfoOriginal,
  RateLimitActionInfo as RateLimitActionInfoOriginal,
  DelayActionInfo as DelayActionInfoOriginal,
  SetVariablesActionInfo as SetVariablesActionInfoOriginal,
  AutomationInfo as AutomationInfoOriginal,
  AutomationInfoOriginInfoOneOf as AutomationInfoOriginInfoOneOfOriginal,
  AutomationInfoTriggerInfo as AutomationInfoTriggerInfoOriginal,
  ActionAttributes as ActionAttributesOriginal,
  AppDefinedActionInfo as AppDefinedActionInfoOriginal,
  ActivationActionStatusChangedStatus as ActivationActionStatusChangedStatusOriginal,
  ActivationActionStatusChangedStatusWithLiterals as ActivationActionStatusChangedStatusWithLiteralsOriginal,
  StartedStatusInfo as StartedStatusInfoOriginal,
  StartedStatusInfoTypeInfoOneOf as StartedStatusInfoTypeInfoOneOfOriginal,
  InvokedAsyncStatusInfo as InvokedAsyncStatusInfoOriginal,
  InvokedAsyncStatusInfoTypeInfoOneOf as InvokedAsyncStatusInfoTypeInfoOneOfOriginal,
  EndedStatusInfo as EndedStatusInfoOriginal,
  EndedStatusInfoTypeInfoOneOf as EndedStatusInfoTypeInfoOneOfOriginal,
  FailedStatusInfo as FailedStatusInfoOriginal,
  ActivationResumeAfterDelay as ActivationResumeAfterDelayOriginal,
  ActionCompletedRequest as ActionCompletedRequestOriginal,
  RefreshPayloadRequest as RefreshPayloadRequestOriginal,
  RefreshPayloadResponse as RefreshPayloadResponseOriginal,
  RunAutomationRequest as RunAutomationRequestOriginal,
  RunAutomationResponse as RunAutomationResponseOriginal,
  RunPreinstalledAutomationRequest as RunPreinstalledAutomationRequestOriginal,
  RunPreinstalledAutomationResponse as RunPreinstalledAutomationResponseOriginal,
  ReportActionInvocationCompletedRequest as ReportActionInvocationCompletedRequestOriginal,
  ReportActionInvocationCompletedRequestStatusInfoOneOf as ReportActionInvocationCompletedRequestStatusInfoOneOfOriginal,
  ReportActionInvocationCompletedResponse as ReportActionInvocationCompletedResponseOriginal,
  ReportEventApplicationErrors as ReportEventApplicationErrorsOriginal,
} from './automations-v2-activation-activations.types.js';
